import { cx } from './cx';

/** 44×26 switch. Uses role="switch" so screen readers announce on/off. */
export function Toggle({
  checked,
  onChange,
  label,
  disabled,
  className,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cx(
        'relative w-11 h-[26px] rounded-full border-0 shrink-0 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed',
        checked ? 'bg-acc' : 'bg-fill2',
        className,
      )}
      style={{ transition: 'background .2s ease' }}
    >
      <span
        aria-hidden="true"
        className="absolute top-[3px] left-[3px] w-5 h-5 rounded-full bg-white"
        style={{
          boxShadow: '0 1px 3px rgba(0,0,0,.25)',
          transform: `translateX(${checked ? 18 : 0}px)`,
          transition: 'transform .25s var(--ease)',
        }}
      />
    </button>
  );
}

/** A labelled row with a switch on the right (settings, wizard review). */
export function ToggleRow({
  title,
  description,
  checked,
  onChange,
  disabled,
  className,
}: {
  title: string;
  description?: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <div className={cx('flex items-center gap-3.5', className)}>
      <div className="flex-1 min-w-0">
        <div className="text-[14px] font-medium">{title}</div>
        {description && <div className="text-[12.5px] text-t4 mt-0.5">{description}</div>}
      </div>
      <Toggle checked={checked} onChange={onChange} label={title} disabled={disabled} />
    </div>
  );
}
